import { useEffect, useState } from 'react';
import styled from 'styled-components';
import cryptoJs from 'crypto-js';


import Logo from '../components/Logo';

function Login() {
    const [id, setId] = useState(null);
    const [password, setPassword] = useState(null);
    const [disabled, setDisabled] = useState(true);

    const certifying = () => {
        fetch('https://api.kerbo.co.kr/auth', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: id,
                password: cryptoJs.SHA256(password).toString(cryptoJs.enc.Hex),
            }),
        }).then((res) => {
            if (res.ok) {
                res.json().then((data) => {
                    window.sessionStorage.setItem('aid', data['ADMIN_ID']);
                    window.sessionStorage.setItem('authcode', data['AUTH_CODE']);
                    window.location.reload();
                });
            } else {
                alert('아이디 혹은 비밀번호 재확인 필요');
            }
        });
    };

    const checkPressEnter = (e) => {
        if (e.key === 'Enter' && !disabled) {
            certifying();
        }
    };

    const onchange = (e) => {
        if (e.target.type === "text") {
            setId(e.target.value);
        }

        if (e.target.type === "password") {
            setPassword(e.target.value);
        }
    }

    useEffect(() => {
        if (id && password) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [id, password])

    return (
        <Background>
            <LoginWrap>
                <Logo size="36" />
                <InputH2>로그인</InputH2>
                <InputWrap>
                    <LoginInput
                        type="text"
                        onChange={onchange}
                        onKeyPress={checkPressEnter}
                        placeholder="아이디"
                    />
                    <LoginInput
                        type="password"
                        onChange={onchange}
                        onKeyPress={checkPressEnter}
                        placeholder="비밀번호"
                    />
                </InputWrap>
                <LoginButton onClick={certifying} disabled={disabled}>로그인</LoginButton>
            </LoginWrap>
        </Background>
    );
}

export default Login;

const Background = styled.section`
    width: 100vw;
    height: 100vh;
    background-color: #323232;

    display: flex;
    justify-content: flex-end;
`;

const LoginWrap = styled.section`
    width: 500px;
    height: 600px;
    background-color: white;
    border-radius: 12px;

    flex-shrink: 0;

    margin: auto 220px;
    padding: 60px;

    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;

const InputH2 = styled.h2`
    margin-top: 68px;

    font-size: 22px;
`;

const InputWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 16px;

    margin-top: 18px;
`;

const LoginInput = styled.input`
    padding-left: 14px;
    height: 46px;
    background-color: #e6e6e6;
    border: none;
    border-radius: 8px;
    outline: none;

    font-size: 16px;
`;

const LoginButton = styled.button`
    margin-top: 146px;
    height: 73px;

    border: none;
    border-radius: 8px;
    background-color: #000000;

    font-size: 22px;
    color: white;

    cursor: pointer;

    &:disabled {
        color: #6C6C6C;
        background-color: #BABABA;
    }
`;
